import React from "react";
import "./App.css";
import Calculator from "./calculator";
import Screen from "./screen";

function App() {
  return (
    <div className="App">
      <Calculator />
    </div>
  );
}

export default App;
